import React, { useEffect, useState } from "react";
import "./AdminPage.css";
import background from "./images/sketch1736085284692.jpg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { authFetch } from "./authFetch";

function AdminPage() {
  const [selectedDate, setSelectedDate] = useState("");
  const [timeSlots, setTimeSlots] = useState([]);
  const [newTimeSlot, setNewTimeSlot] = useState("");
  const [appointments, setAppointments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Adminisztrációs felület";
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const response = await authFetch("/api/appointments/");
      const data = await response.json();
      const aptList = Array.isArray(data) ? data : (data.appointments || []);
      setAppointments(aptList);
    } catch (error) {
      console.error("Hiba:", error);
    }
  };

  const handlePaidChange = async (id, val) => {
    try {
      await authFetch(`/api/update-appointment/${id}/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ paid: val }),
      });
      setAppointments(prev => prev.map(ap => ap.id === id ? { ...ap, paid: val } : ap));
      Swal.fire({ title: "Siker", text: "Fizetés frissítve", icon: "success", timer: 1000, showConfirmButton: false });
    } catch (e) { console.error(e); }
  };

  const handleTattooedChange = async (id, val) => {
    if (!val) return;
    Swal.fire({
      title: "Kész a tetoválás?",
      text: "A sor törlődni fog a listából.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#5cb85c",
      confirmButtonText: "Igen",
      cancelButtonText: "Mégse"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await authFetch(`/api/update-appointment/${id}/`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ tattooed: true }),
          });
          setAppointments(prev => prev.filter(ap => ap.id !== id));
        } catch (e) { console.error(e); }
      }
    });
  };

  const handleSaveTimeSlots = async () => {
    if (!selectedDate || timeSlots.length === 0) {
      Swal.fire("Hiba", "Válassz dátumot és időpontot!", "error");
      return;
    }
    try {
      const resp = await authFetch("/api/save-time-slots/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ date: selectedDate, time_slots: timeSlots }),
      });
      if (resp.ok) {
        Swal.fire("Siker", "Mentve!", "success").then(() => {
          setSelectedDate("");
          setTimeSlots([]);
        });
      }
    } catch (e) { console.error(e); }
  };

  return (
    <div className="admin-page-wrapper" style={{ backgroundImage: `url(${background})`, backgroundSize: 'cover', minHeight: '100vh', padding: '20px' }}>
      <div className="button-container" style={{display: 'flex', justifyContent: 'flex-end', gap: '10px', marginBottom: '20px'}}>
        <button className="view-timeslots-button" onClick={() => navigate("/timeslots")} style={{padding: '10px'}}>Szabad időpontok</button>
        <button className="logout-button" onClick={() => {localStorage.removeItem("authToken"); window.location.href="/login"}} style={{padding: '10px'}}>Kijelentkezés</button>
      </div>

      <div className="admin-container" style={{ margin: "20px auto", maxWidth: "500px", backgroundColor: "rgba(151, 130, 116, 0.9)", padding: "20px", borderRadius: "8px", color: "white", textAlign: "center" }}>
        <h1>Időpontok rögzítése</h1>
        <div style={{ marginBottom: "15px", textAlign: "left" }}>
          <label>Dátum:</label>
          <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} style={{ width: "100%", padding: "8px", marginTop: "5px" }} />
        </div>
        <div style={{ marginBottom: "15px", textAlign: "left" }}>
          <label>Új időpont:</label>
          <input type="time" value={newTimeSlot} onChange={(e) => setNewTimeSlot(e.target.value)} style={{ width: "100%", padding: "8px", marginTop: "5px" }} />
          <div style={{ marginTop: "10px" }}>
            <button onClick={() => {if(newTimeSlot) setTimeSlots([...timeSlots, newTimeSlot]); setNewTimeSlot("");}} style={{ padding: "8px", marginRight: "10px" }}>Hozzáadás listához</button>
            <button onClick={handleSaveTimeSlots} style={{ padding: "8px", backgroundColor: "#5cb85c", color: "white", border: "none" }}>MENTÉS ADATBÁZISBA</button>
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>{timeSlots.join(", ")}</div>
      </div>

      <div className="appointments-container" style={{ margin: "0 auto", maxWidth: "1100px", backgroundColor: "rgba(151, 130, 116, 0.9)", padding: "20px", borderRadius: "12px", color: "white" }}>
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Foglalások listája</h2>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "2px solid white" }}>
                <th style={{ padding: "10px", textAlign: "left" }}>Vendég</th>
                <th style={{ textAlign: "left" }}>E-mail / Telefon</th>
                <th style={{ textAlign: "center" }}>Időpont</th>
                <th style={{ textAlign: "center" }}>Fizetve</th>
                <th style={{ textAlign: "center" }}>Kész</th>
              </tr>
            </thead>
            <tbody>
              {appointments.map((ap) => {
                const d = new Date(ap.reserved);
                const dateStr = d.toLocaleDateString('hu-HU');
                const timeStr = d.toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' });
                return (
                  <tr key={ap.id} style={{ borderBottom: "1px solid rgba(255,255,255,0.3)" }}>
                    <td style={{ padding: "10px", fontWeight: "bold" }}>{ap.last_name} {ap.first_name}</td>
                    <td>{ap.email}<br/><span style={{fontSize: "0.8rem", color: "#eee"}}>{ap.phone}</span></td>
                    <td style={{ textAlign: "center" }}>
                        <div style={{fontWeight: "bold"}}>{dateStr}</div>
                        <div style={{color: "#dfd"}}>{timeStr}</div>
                    </td>
                    <td style={{ textAlign: "center" }}>
                        <input type="checkbox" checked={ap.paid || false} onChange={(e) => handlePaidChange(ap.id, e.target.checked)} />
                    </td>
                    <td style={{ textAlign: "center" }}>
                        <input type="checkbox" checked={ap.tattooed || false} onChange={(e) => handleTattooedChange(ap.id, e.target.checked)} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
